import { assetUrl } from '../http/build-url';
import { asBoolean, asNumber, asString } from '../http/normalise';
import { ApiMapPin, ApiRoom, ApiVenueMap } from './room.dto';
import { MapPin, Room, RoomType, VenueMap } from './room.model';

const ROOM_TYPES: ReadonlySet<string> = new Set<string>([
  'stage',
  'room',
  'hall',
  'breakout',
  'networking',
  'booth-zone',
]);

function asRoomType(value: unknown): RoomType {
  if (typeof value === 'string' && ROOM_TYPES.has(value)) {
    return value as RoomType;
  }
  return 'room';
}

function mapPin(dto: ApiMapPin | null | undefined): MapPin | null {
  const x = asNumber(dto?.x);
  const y = asNumber(dto?.y);

  if (x === null || y === null) {
    return null;
  }

  return { x, y };
}

export function mapRoom(dto: ApiRoom): Room {
  return {
    id: asString(dto.id) ?? '',
    eventId: asString(dto.eventId) ?? '',
    name: asString(dto.name) ?? '',
    type: asRoomType(dto.type),
    capacity: asNumber(dto.capacity),
    floor: asString(dto.floor),
    description: asString(dto.description),
    mapPin: mapPin(dto.mapPosition),
    accessZoneId: asString(dto.accessZoneId),
    colorHex: asString(dto.displayColor),
    sortOrder: asNumber(dto.sortOrder) ?? 0,
    archived: asBoolean(dto.archived, false),
  };
}

export function mapVenueMap(dto: ApiVenueMap, storageBase: string): VenueMap {
  return {
    eventId: asString(dto.eventId) ?? '',
    imageUrl: assetUrl(storageBase, dto.imageUrl) ?? '',
    imagePath: asString(dto.imageUrl) ?? '',
    width: asNumber(dto.width) ?? 0,
    height: asNumber(dto.height) ?? 0,
  };
}
